<template>
  <div>
    <section>
      <div class="accordion" id="accordionExample">
        <div class="" v-if="anyOf">
          <div
            class="d-flex align-items-center justify-content-between"
            id="headingOne"
            v-if="enabled[0]"
          >
            <h2 class="mb-0">
              <button
                class="btn btn-sm btn-link"
                type="button"
                data-toggle="collapse"
                data-target="#collapseOne"
                aria-expanded="false"
                aria-controls="collapseOne"
              >
                {{ $t("lang.search.isanyof") }}
                <small v-if="tags_any.length > 0">
                  <span class="badge-primary badge-sm rounded px-1 ml-1">{{
                    tags_any.length
                  }}</span></small
                >
              </button>
            </h2>
            <span
              v-if="showSubcategoryClear && tags_any.length > 0 && !isDisabled"
              class="text-primary cursor-pointer mx-2"
              @click="clearSubcategory('anyof')"
            >
              <i class="icon-close"></i>
            </span>
          </div>

          <div
            id="collapseOne"
            :key="cant"
            class="collapse show"
            aria-labelledby="headingOne"
            data-parent="#accordionExample"
            v-if="enabled[0]"
          >
            <div class="">
              <multiselect
                v-model="tags_any"
                v-bind:tag-placeholder="$t('lang.search.add')"
                v-bind:placeholder="$t('lang.search.addoneorseveralwords')"
                label="word"
                track-by="id"
                :options="tags_any"
                :multiple="true"
                :taggable="true"
                :searchable="true"
                :showLabels="true"
                :disabled="isDisabled"
                openDirection="below"
                class="small"
                @remove="onRemoveTag($event, tags_any, 'anyof')"
                @tag="addTag($event, tags_any, 'anyof')"
              >
                <template slot="tag" slot-scope="props">
                  <span
                    class="mr-1 p-1 text-white rounded"
                    :class="tagClass(props.option.word)"
                    :title="tagTitle(props.option.word)"
                  >
                    <span v-text="props.option.word"></span>
                    <i
                      @click="removeTag(props.option, tags_any, 'anyof')"
                      class="icon-close pl-1 cursor-pointer"
                    ></i>
                  </span>
                </template>
              </multiselect>
              <i 
              v-if="hasWordsToCopy && hasPermissions('superAdmin') && this.$route.fullPath.includes('/orders/')"
              class="icon icon-clipboard cursor-pointer mr-2 ml-2"
              :title="$t('lang.general.copytoclipboard')"
              @click="copyContent(1)"></i>
            </div>
          </div>
        </div>
        <div class="" v-if="notAnyOf">
          <div
            class="d-flex align-items-center justify-content-between"
            id="headingTwo"
            v-if="enabled[1]"
          >
            <h2 class="mb-0">
              <button
                class="btn btn-sm btn-link collapsed"
                type="button"
                data-toggle="collapse"
                data-target="#collapseTwo"
                aria-expanded="false"
                aria-controls="collapseTwo"
              >
                {{ $t("lang.search.isnotanyof") }}
                <small v-if="tags_not_any.length > 0">
                  <span class="badge-primary badge-sm rounded px-1 ml-1">{{
                    tags_not_any.length
                  }}</span></small
                >
              </button>
            </h2>
            <span
              v-if="showSubcategoryClear && tags_not_any.length > 0 && !isDisabled"
              class="text-primary cursor-pointer mx-2"
              @click="clearSubcategory('notanyof')"
            >
              <i class="icon-close"></i>
            </span>
          </div>
          <div
            id="collapseTwo"
            class="collapse"
            :class="!anyOf ? 'show' : ''"
            aria-labelledby="headingTwo"
            data-parent="#accordionExample"
            v-if="enabled[1]"
          >
            <div class="">
              <multiselect
                v-model="tags_not_any"
                v-bind:tag-placeholder="$t('lang.search.add')"
                v-bind:placeholder="$t('lang.search.addoneorseveralwords')"
                label="word"
                track-by="id"
                :options="tags_not_any"
                :multiple="true"
                :taggable="true"
                :searchable="true"
                :disabled="isDisabled"
                :showLabels="false"
                openDirection="below"
                class="small"
                @remove="removeTag($event, tags_not_any, 'notanyof')"
                @tag="addTag($event, tags_not_any, 'notanyof')"
              >
                <template slot="tag" slot-scope="props">
                  <span
                    class="multiselect__tag pr-2 py-1"
                    :class="tagClass(props.option.word)"
                    :title="tagTitle(props.option.word)"
                  >
                    <span v-text="props.option.word"></span>

                    <i
                      @click="removeTag(props.option, tags_not_any, 'notanyof')"
                      class="icon-close pl-1 cursor-pointer"
                    ></i>
                  </span>
                </template>
              </multiselect>
            </div>
          </div>
          <i 
          v-if="hasWordsToCopy && hasPermissions('superAdmin') && this.$route.fullPath.includes('/orders/')"
          class="icon icon-clipboard cursor-pointer mr-2 ml-2"
          :title="$t('lang.general.copytoclipboard')"
          @click="copyContent(0)"></i>
        </div>
        <div v-if="false" class="">
          <div class="" id="headingThree" v-if="enabled[2]">
            <h2 class="mb-0">
              <button
                class="btn btn-link collapsed"
                type="button"
                data-toggle="collapse"
                data-target="#collapseThree"
                aria-expanded="false"
                aria-controls="collapseThree"
              >
                Is known
              </button>
            </h2>
          </div>
          <div
            id="collapseThree"
            class="collapse"
            aria-labelledby="headingThree"
            data-parent="#accordionExample"
            v-if="enabled[2]"
          >
            <div class="">
              <multiselect
                v-model="tags_know"
                v-bind:tag-placeholder="$t('lang.search.add')"
                v-bind:placeholder="$t('lang.search.addoneorseveralwords')"
                label="word"
                track-by="id"
                :options="tags_know"
                :multiple="true"
                :disabled="isDisabled"
                :taggable="true"
                :searchable="true"
                :showLabels="false"
                openDirection="below"
                class="small"
                @remove="removeTag($event, tags_know, 'known')"
                @tag="addTag($event, tags_know, 'known')"
              >
                <template slot="tag" slot-scope="props">
                  <span class="multiselect__tag bg-primary">
                    <span v-text="props.option.word"></span>
                  </span>
                </template>
              </multiselect>
            </div>
          </div>
        </div>
        <div v-if="false" class="">
          <div class="" id="headingThree" v-if="enabled[3]">
            <h2 class="mb-0">
              <button
                class="btn btn-link collapsed"
                type="button"
                data-toggle="collapse"
                data-target="#collapseFour"
                aria-expanded="false"
                aria-controls="collapseFour"
              >
                Is unknown
              </button>
            </h2>
          </div>
          <div
            id="collapseFour"
            class="collapse"
            aria-labelledby="headingThree"
            data-parent="#accordionExample"
            v-if="enabled[3]"
          >
            <div class="">
              <multiselect
                v-model="tags_unknow"
                v-bind:tag-placeholder="$t('lang.search.add')"
                v-bind:placeholder="$t('lang.label.addoneorseveralwords')"
                label="word"
                track-by="id"
                :options="tags_unknow"
                :multiple="true"
                :taggable="true"
                :disabled="isDisabled"
                :searchable="true"
                :showLabels="false"
                openDirection="below"
                class="small"
                @remove="removeTag($event, tags_unknow, 'unknown')"
                @tag="addTag($event, tags_unknow, 'unknown')"
              >
                <template slot="tag" slot-scope="props">
                  <span class="multiselect__tag bg-primary">
                    <span v-text="props.option.word"></span>
                  </span>
                </template>
              </multiselect>
            </div>
          </div>
        </div>
        <!-- <i 
        v-if="hasWordsToCopy && hasPermissions('superAdmin') && this.$route.fullPath.includes('/orders/')"
        class="icon icon-clipboard cursor-pointer mr-2 ml-2"
        :title="$t('lang.general.copytoclipboard')"
        @click="copyContent()"></i> -->
      </div>
    </section>
  </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import Vue from "vue";
Vue.component("multiselect", Multiselect);

export default {
  props: {
    default_values: {
      type: [Object, Array],
      required: true,
      default: () => {}
    },
    taglimit: {
      type: Number,
      required: false,
      default: 10000
    },
    taglimitNotAnyOf: {
      type: Number,
      required: false,
      default: null
    },
    enabled: {
      type: Array,
      required: false,
      default: () => [true, true, false, false]
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: () => false
    },
    multipleValuesAtOnce: {
      type: Boolean,
      required: false,
      default: () => false
    },
    anyOf: {
      type: Boolean,
      required: false,
      default: () => true
    },
    notAnyOf: {
      type: Boolean,
      required: false,
      default: () => true
    },
    showSubcategoryClear: {
      type: Boolean,
      required: false,
      default: () => false
    },
    tagStatus: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  data() {
    return {
      tags_any: [],
      tags_not_any: [],
      tags_know: [],
      tags_unknow: [],
      cant: 0
    };
  },

  components: {
    Multiselect
  },
  created() {
    this.init_tags("anyof");
    this.init_tags("notanyof");
    this.init_tags("known");
    this.init_tags("unknown");
  },
  computed: {
    hasWordsToCopy() {
      const { anyof = [], notanyof = [] } = this.default_values || {};
      return (
        anyof.some(item => item.word && item.word.trim() !== "") ||
        notanyof.some(item => item.word && item.word.trim() !== "")
      );
    }
  },
  methods: {
    tagClass(word) {
      const status = this.tagStatus[word];
      if (status === "applied") {
        return "bg-success";
      }
      if (status === "ignored") {
        return "bg-warning text-dark";
      }
      if (status === "unknown") {
        return "bg-secondary";
      }
      return "bg-primary";
    },
    tagTitle(word) {
      const status = this.tagStatus[word];
      if (status === "applied") {
        return this.$t("lang.search.filter_applied");
      }
      if (status === "ignored") {
        return this.$t("lang.search.filter_ignored");
      }
      if (status === "unknown") {
        return this.$t("lang.search.filter_unknown");
      }
      return "";
    },
    hasPermissions(perm) {
      return this.$store.getters["authentication/hasPermissions"](perm);
    },
    copyContent(from){
      try {
        // Aseguramos que la variable exista
        const data = this.default_values || {};

        // Extraemos anyof y notanyof (si existen)
        const { anyof = [], notanyof = [] } = data;

        // Unimos ambos arrays y tomamos solo la propiedad "word"
        let words = [];  
        if(from == 1){
           words = [...anyof]
        }else{
           words = [...notanyof]
        }
        words = words
          .map(item => item.word)
          .filter(Boolean); // quita vacíos o undefined

        // Creamos el texto final
        const textToCopy = words.join(", ");

        // Si no hay nada, avisamos
        if (!textToCopy) {
          return;
        }

        // Intentamos copiar al portapapeles
        navigator.clipboard.writeText(textToCopy)
          .then(() => {
          })
          .catch(() => {
            // Fallback para navegadores antiguos
            const textarea = document.createElement("textarea");
            textarea.value = textToCopy;
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand("copy");
            document.body.removeChild(textarea);
          });
      } catch (error) {
        console.error("Error al copiar contenido:", error);
      }
    },
    init_tags(type) {
      if (this.default_values[type] === undefined) {
        this.default_values[type] = [];
      } else {
        // Decode any HTML entities in existing tags (especially &amp; -> &)
        this.default_values[type].forEach(item => {
          if (item.word && item.word.includes("&amp;")) {
            item.word = this.decodeHtmlEntities(item.word);
          }
        });
        
        switch (type) {
          case "anyof":
            this.tags_any = this.default_values[type];
            break;
          case "notanyof":
            this.tags_not_any = this.default_values[type];
            break;
          case "known":
            this.tags_know = this.default_values[type];
            break;
          case "unknown":
            this.tags_unknow = this.default_values[type];
            break;
        }
      }
    },
    decodeHtmlEntities(text) {
      // Decode common HTML entities, especially &amp; back to &
      if (!text) return text;
      return text
        .replace(/&amp;/g, "&")
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&quot;/g, '"')
        .replace(/&#039;/g, "'");
    },
    addTag(newTag, tagsany, type) {
      //if it supports multiple values ​​separated by commas
      if (this.multipleValuesAtOnce) {
        if (newTag.includes(",")) {
          const listOfValues = newTag
            .split(",")
            .map(el => el.trim())
            .map(e => this.decodeHtmlEntities(this.$sanitize(e)));

          listOfValues.forEach(item => {
            const valueFound = tagsany.find(e => e.word === item);
            if (!valueFound) this.addTagValue(item, tagsany, type);
          });
        } else {
          this.addTagValue(newTag, tagsany, type);
        }
      } else {
        this.addTagValue(newTag, tagsany, type);
      }
    },
    addTagValue(newTag, tagsany, type) {
      const tag = {
        word: this.decodeHtmlEntities(this.$sanitize(newTag))
      };
      const limit =
        type === "notanyof" && this.taglimitNotAnyOf !== null
          ? this.taglimitNotAnyOf
          : this.taglimit;
      if (tagsany.length < limit) {
        tagsany.push(tag);
        if (tagsany != undefined && tagsany.length > 0) {
          tagsany = tagsany.filter(t => t.word != tag.word);
          this.default_values[type] = tagsany;
        }
        this.default_values[type].push(tag);
        this.cant++;
        this.$emit("quantity", this.cant);
        this.$emit("change", this.default_values);
      }
    },
    onRemoveTag(tag, tags_any, type) {
      this.$nextTick(() => {
        this.removeTag(tag, tags_any, type);
      });
    },
    removeTag(tag, tagsany, type) {
      if (tagsany != undefined && tagsany.length > 0) {
        tagsany = tagsany.filter(t => t.word != tag.word);
        this.default_values[type] = tagsany;
      }
      if (type == "anyof") {
        this.tags_any = tagsany;
      }

      if (type == "notanyof") {
        this.tags_not_any = tagsany;
      }

      if (type == "known") {
        this.tags_know = tagsany;
      }

      if (type == "unknown") {
        this.tags_unknow = tagsany;
      }
      this.cant--;
      this.$emit("quantity", this.cant);
      this.$emit("change", this.default_values);
    },
    clearSubcategory(type) {
      if (this.isDisabled) return;

      this.default_values[type] = [];

      if (type === "anyof") {
        this.tags_any = [];
      } else if (type === "notanyof") {
        this.tags_not_any = [];
      }

      this.cant++;
      this.$emit("quantity", this.cant);
      this.$emit("change", this.default_values);
    }
  }
};
</script>
